import { request } from "services";
import { Policy } from "types";

const getToken = (code: string, policy?: Policy) => {
  const path = "/auth/token";
  const method = "POST";
  const data = {
    code,
    policy_name: policy || "B2C_1_Authentication",
    platform: "web",
  };

  return request({ path, method, data }).then((res) => {
    return res.data.d.token as string;
  });
};

export { getToken };
